import { createSlice } from '@reduxjs/toolkit'

const cinestarClubSlice = createSlice({
    name: 'cinestar-club',
    initialState: {
        loading: false,
        error: null,
        coupons: [],
        rewards: [],
        transactions: [],
    },
    reducers: {
        setLoading(state, action) {
            const { payload } = action

            state.loading = payload
        },
        setError(state, action) {
            const { payload } = action

            if (!payload) {
                return { ...state, error: null }
            }

            return { ...state, error: payload }
        },
        setCoupons(state, action) {
            const { payload } = action
            return { ...state, coupons: payload }
        },

        setRewards(state, action) {
            const { payload } = action
            return { ...state, rewards: payload }
        },
        setTransactions(state, action) {
            const { payload } = action
            return { ...state, transactions: payload }
        },
        getCinestarClub() {},
    },
})

const { actions, reducer } = cinestarClubSlice

export const { setLoading, setError, setCoupons, setRewards, setTransactions, getCinestarClub } = actions

export default reducer
